import React from "react";

export default function EssentialFeature({ title, description, icon }) {
  return (
    <section className="items-center p-4 text-center md:p-5 2xl:p-6">
      <div className="mb-3 flex justify-center">{icon}</div>
      <header>
        <h2 className="mb-1.5 text-wrap text-center font-manrope text-[15px] font-extrabold leading-snug text-[#333333] md:text-[17px] 2xl:text-[19px]">
          {title}
        </h2>

        <p className="text-center font-manrope text-[11px] font-medium leading-relaxed text-[#666A7C] md:text-[12px] 2xl:text-[13px]">
          {description}
        </p>
      </header>
    </section>
  );
}
